export const SEGMENTS = [
  { key: "prospects", label: "Prospects importés", hint: "Toute la base « Contacts vérifiés » (adresses contrôlées à l'import)" },
  { key: "members", label: "Membres inscrits sans bougie", hint: "Inscrits sur le site qui n'ont encore rien acheté" },
  { key: "customers", label: "Clients avec une bougie allumée", hint: "Ont au moins une bougie active ou éternelle" },
  { key: "expired", label: "Clients dont la bougie est éteinte", hint: "Toutes leurs bougies sont éteintes : à relancer" },
];

export const STATUS_FR = {
  pending: "En attente", sent: "Envoyé", opened: "Ouvert", clicked: "A cliqué", registered: "Inscrit",
  purchased: "A acheté", unsubscribed: "Désinscrit", error: "Erreur",
};

export const CAMP_STATUS = {
  draft: { label: "Brouillon", cls: "bg-white/10 text-white/70" },
  active: { label: "En cours d'envoi", cls: "bg-emerald-500/15 text-emerald-300" },
  paused: { label: "En pause", cls: "bg-amber-400/15 text-amber-300" },
  done: { label: "Terminée", cls: "bg-sky-500/15 text-sky-300" },
  stopped: { label: "Arrêtée", cls: "bg-rose-500/15 text-rose-300" },
};

export const StatPill = ({ label, value, accent, testid }) => (
  <div className="rounded-xl border border-white/10 bg-white/[0.03] px-3 py-2 text-center" data-testid={testid}>
    <div className={`text-lg font-bold tabular-nums ${accent || "text-sky-300"}`}>{value}</div>
    <div className="text-[11px] text-muted-foreground">{label}</div>
  </div>
);

export const fmtDate = (iso) => {
  if (!iso) return "—";
  try { return new Date(iso).toLocaleString("fr-FR", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" }); } catch { return "—"; }
};
